import { Box, styled } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export const PDFPageSelectionControlsContainer = styled(Box, {
  shouldForwardProp: prop => prop !== '$allowPageSelection' && prop !== '$isPopped',
})<{ $allowPageSelection: boolean; $isPopped?: boolean; }>(
  ({ $allowPageSelection }) => ({
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'flex-start',
    width: 'auto',
    height: 'fit-content',
    gap: '30px',
    flexWrap: 'wrap',
    alignContent: 'space-around',
    paddingTop: '6px',
    paddingBottom: '6px',
    paddingLeft: '50px',
    position: $allowPageSelection ? 'sticky' : 'relative',
    top: $allowPageSelection ? 0 : undefined,
    zIndex: $allowPageSelection ? 10000 : undefined,
  })
);

export const actionsBoxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};
